import { render, staticRenderFns } from "./ComfirmEmail.vue?vue&type=template&id=1075c3a8&scoped=true"
import script from "./ComfirmEmail.vue?vue&type=script&lang=js"
export * from "./ComfirmEmail.vue?vue&type=script&lang=js"
import style0 from "./ComfirmEmail.vue?vue&type=style&index=0&id=1075c3a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1075c3a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VCol,VContainer,VForm,VMain,VRow,VTextField})
